import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import SmallModalTemplate from 'src/components/SmallModalTemplate';

import { I18NextNS } from 'src/models/Language.model';

export type CancelOrderSuccessModalProps = {
  show: boolean;
  onClose: () => void;
};

export default function CancelOrderSuccessModal({
  show,
  onClose,
}: CancelOrderSuccessModalProps) {
  const { t } = useTranslation(I18NextNS.COMMON);

  return (
    <SmallModalTemplate
      show={show}
      onHide={onClose}
      iconWrapperClassName="bg-success-subtle"
      icon={
        <FontAwesomeIcon icon={faCheck} className="text-success" size="sm" />
      }
      title={t('orderDetails.cancelOrderSuccessTitle')}
      description={t('orderDetails.cancelOrderSuccessDescription')}
      rightButton={
        <Button
          variant="outline-primary"
          onClick={onClose}
          data-test="cancel-order-success-close"
          data-track="exam.cancel-order-success-modal.close"
          data-observe
        >
          {t('orderDetails.cancelOrderSuccessClose')}
        </Button>
      }
    />
  );
}
